import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GetApplicationForDetailsResponse } from 'it/primatoo/openapi/api/org/schemas/application/getapplicationfordetailsresponse/GetApplicationForDetailsResponse';
import { IoniconsFilled, IoniconsOutline, ND } from '@pt/pt-models';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfigureCveDialogComponent } from './dialog/configure-cve-dialog.component';
import { AppLinkBuilder } from '../../../utils/app-link-builder';

@Component({
  selector: 'pt-details-application-cve',
  templateUrl: './details-application-cve.component.html',
  styleUrls: ['./details-application-cve.component.scss'],
})
export class DetailsApplicationCveComponent {
  @Input() appDetails!: GetApplicationForDetailsResponse;

  @Output() openAuditDialog = new EventEmitter<boolean>();
  @Output() changeSecurityToolTypeValue = new EventEmitter<boolean>();
  @Output() errorMessage = new EventEmitter<string>();

  public IconTrash = IoniconsFilled.trash;
  public IconWarning = IoniconsOutline.warning;
  public readonly dateFormat = 'dd/MM/yyyy HH:mm';
  private modalRef: NgbModalRef;
  protected readonly ND = ND;

  navigateToUser(authorId?: number) {
    if (authorId) {
      window.open(AppLinkBuilder.linkOfEntity('users', authorId), '_blank');
    }
  }

  constructor(private modalService: NgbModal) {}

  configureCVE() {
    this.modalRef = this.modalService.open(ConfigureCveDialogComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg',
    });
    this.modalRef.componentInstance.load(this.appDetails);

    this.modalRef.componentInstance.close$.subscribe(
      (response: { message?: string; reload: boolean }) => {
        if (response?.message) {
          this.errorMessage.emit(response?.message);
        }
        if (response?.reload) {
          this.changeSecurityToolTypeValue.emit();
        }

        if (this.modalRef) {
          this.modalRef.close();
          this.modalRef = undefined;
        }
      }
    );
  }
}
